import React from 'react';

const CalculationCoverageIcon = (props) => {

  let icon = "info";
  let color = "success";
  let padding = "0";

  switch (props.status) {
    case 'greater_than_max':
      icon = "block";
      color = "danger";
      padding = "0";
      break;
    case 'between_max_and_krit':
      icon = "warning";
      color = "warning";
      padding = "3";
      break;
    case 'lower_than_krit':
      icon = "check";
      color = "success"
      padding = "0";
      break;
    default:
      icon = "";
  }

  return <span className={"btn btn-round bg-" + color} style={{width: "1.5rem", height: "1.5rem", display: "inline-flex", paddingBottom: padding + "px", marginLeft: "5px"}}>
    <i className="material-icons text-white" style={{fontSize: "1.3rem"}}>{icon}</i>
  </span>

}

export default CalculationCoverageIcon



// WEBPACK FOOTER //
// ./src/components/Modals/CalculationCoverageIcon.js